import React from "react";
import { useNavigate } from "react-router-dom";

function Listings({ properties = [], setBanner }) {
  const navigate = useNavigate();

  if (!properties || properties.length === 0) {
    return (
      <div className="container mt-5">
        <h2>Listings</h2>
        <p className="text-muted">No properties available at the moment.</p>
      </div>
    );
  }

  const handleViewDetails = (id) => {
    if (!id) {
      setBanner?.({ type: "danger", message: "Invalid property ID." });
      return;
    }
    navigate(`/property/${id}`, { state: { from: "listings" } });
  };

  return (
    <div className="container mt-5">
      <h2>Listings</h2>
      <div className="row">
        {properties.map((p) => (
          <div key={p.id} className="col-md-4 mb-3">
            <div className="card h-100 shadow-sm">
              {p.images && p.images.length > 0 && p.images[0].src ? (
                <img
                  src={p.images[0].src}
                  alt={p.title || "Property image"}
                  className="card-img-top fixed-img"
                />
              ) : (
                <div className="card-img-top bg-light text-center p-5 text-muted">
                  No Image
                </div>
              )}

              <div className="card-body d-flex flex-column">
                <h5 className="card-title">{p.title || "Untitled Property"}</h5>
                <p className="mb-2">{p.location || "Location not specified"}</p>
                <p>
                  <strong>Price:</strong> PHP {p.price || "N/A"}
                </p>
                <button
                  className="btn btn-primary mt-auto"
                  onClick={() => handleViewDetails(p.id)}
                >
                  View Details
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Listings;
